import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import { A } from 'components/common/Link/Link'
import { Wrapper, Logo, Name } from '../sharedComponents'
import { DEFAULT_VEHICLE_ASSET } from 'constant'

const AddVehicleTile = ({
  className,
  onClick = () => {},
  ...props
}) =>
  <Wrapper { ...props } className={ className } onClick={ onClick }>
    <Logo>
      <VechicleIcon asset={ DEFAULT_VEHICLE_ASSET } />
    </Logo>
    <AddNew data-at-add-appointment-vehicle anchor><Name>+ Add a Vehicle</Name></AddNew>
  </Wrapper>

AddVehicleTile.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default AddVehicleTile

const AddNew = styled(A)`
  display: block;
  margin: 10px 0;
  text-align: center;
`

const VechicleIcon = styled(Icon)`
  ${Media.mobile`
    max-width: 53px;
  `}
`
